export const interior_view05ImageOptions = {
  angle: 'interior_view05',
  staticOptions: {
    Floorboard: 1,
    Fabric: 1,
    FabricOwnersCabin: 1,
    CupboardsOwnersCabin: 1,
    BedsideCompartment: 1,
    Wardrobe: 1,
    AftCabinLayout: 1,
    Mast: 1,
    Wheel: 1,
    FabricSeatOwnersCabin: 1,
    FabricFreehung: 1
  },
  mattes: [
    {
      option: 'Floorboard',
      dependency: null
    },
    {
      option: 'Fabric',
      dependency: 'AftCabinLayout'
    },
    {
      option: 'Mast',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xc47/views/interior_view05.js